import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-003613e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = { class: "login-type user-inform" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-right-to-bracket" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-plus" }, null, -1))
const _hoisted_6 = { class: "user-inform" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" }, null, -1))
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-shield" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1))

import { ref, onMounted, watch, computed } from "vue";
import store from "@/store/index";
import { useRouter } from "vue-router";
import { COOKIE_USERS_SESSION } from "@/const/cookie";
import commons from "@/utils/Common";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInforClient',
  setup(__props) {

const router = useRouter();
const name = ref("");
const url = ref("");

const isNotLogin = ref(false);
const isLogin = ref(false);
const logOut = async () => {
  commons.logOut()
  await loadData()
  router.push({ path: "./" });
};

const isLoadLogin = computed(() => {
  return store.getters.isLoadLogin;
});
const changePassword = async () => {
  router.push({ path: "/password" });
};
onMounted( async () => {
  await loadData()
});

const loadData = () => {
  let user = commons.getCookies(COOKIE_USERS_SESSION);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  } 
  // else {
  //   isNotLogin.value = true
  //   isLogin.value = false
  // }
  isLogin.value = commons.checkLogin()
}

watch(isLoadLogin, async (newValue, oldValue) => {
  await loadData()
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/favourite",
        class: "type-icon"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.$t('text.favourite')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/login",
        class: "type-icon"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.$t('loginForm.login')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/registers",
        class: "type-icon"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.$t('loginForm.register')), 1)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !isLogin.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: "favourite",
        class: "type-icon"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.$t('text.favourite')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_dropdown, { class: "login-type" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { onClick: changePassword }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('text.changePass')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { onClick: logOut }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('loginForm.logout')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "",
              class: "type-icon"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  size: 16,
                  src: url.value
                }, null, 8, ["src"]),
                _createTextVNode(" " + _toDisplayString(name.value), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, isLogin.value]
    ])
  ]))
}
}

})